import { FacetType } from 'common/types/facet';
import { Facet, FacetValue, GroupedFacetValue, Response } from 'common/types/search-response';

const groupByAsc = (item: Facet, values: FacetValue[]) => {
  const sortedByName = values.sort((a: FacetValue, b: FacetValue) => {
    if (a.name[0].toLowerCase() > b.name[0].toLowerCase()) {
      return 1;
    }
    if (a.name[0].toLowerCase() < b.name[0].toLowerCase()) {
      return -1;
    }
    return 0;
  });

  const dataGrouped = sortedByName.reduce((r: Record<string, GroupedFacetValue>, val: FacetValue) => {
    // get first letter of name of current element
    const group = Number.isNaN(parseInt(val.name[0], 10)) ? val.name[0].toUpperCase() : '#';
    // if there is no property in accumulator with this letter create it
    if (!r[group]) r[group] = { group, items: [val] };
    // if there is push current element to children array for that letter
    else r[group].items.push(val);
    // return accumulator
    return r;
  }, {});

  // since data at this point is an object, to get array of values
  // we use Object.values method
  const result: GroupedFacetValue[] = Object.values(dataGrouped);

  return { ...item, values: result };
};

const isBrandFacet = ({ id }: { id: string }) => id === FacetType.brand;

export const normalizeBrandFacet = (data: Response) => {
  if (!data || data?.facet_list?.length === 0) return data;

  const { facet_list } = data;
  const sortedFacetList = (facet_list as Facet[]).map((item) =>
    isBrandFacet({ id: item.id }) ? groupByAsc(item, item.values as FacetValue[]) : item,
  );

  data.facet_list = sortedFacetList;

  return data;
};
